import { render, staticRenderFns } from "./Gallery15.vue?vue&type=template&id=34a80c08&scoped=true&"
import script from "./Gallery15.vue?vue&type=script&lang=js&"
export * from "./Gallery15.vue?vue&type=script&lang=js&"
import style0 from "./Gallery15.vue?vue&type=style&index=0&id=34a80c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a80c08",
  null
  
)

export default component.exports